<script setup lang="ts">
import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useItemsStore } from "~/stores/items";
import { useModalStore } from "~/stores/modal";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { itemsConfirmDelete } = useModalStore();
const itemsStore = useItemsStore();

const submitItemDelete = async () => {
	const { itemPrototype } = itemsConfirmDelete.item;
	await itemsStore.deleteById(itemsConfirmDelete.item.id);

	itemsConfirmDelete.closeModal();

	if (route.name === "products-item-prototypes-prototype-items-item") {
		navigateTo(`/products/item-prototypes/${itemPrototype.id}`);
	} else if (route.name === "products-item-prototypes-prototype") {
		itemsStore.getAll({}, itemsStore.recentGetAllQuery);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.ITEMS.CONFIRM_DELETE.alert.title"),
		description: t("COMPONENTS.ITEMS.CONFIRM_DELETE.alert.description"),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.ITEMS.CONFIRM_DELETE.title')"
		:description="$t('COMPONENTS.ITEMS.CONFIRM_DELETE.description')"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesDelete')"
		@close="itemsConfirmDelete.closeModal"
		@submit="submitItemDelete"
	/>
</template>
